// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__cOT-0","searchBar":"SearchBox_searchBar__YZpmF","searchInput":"SearchBox_searchInput__P+qPV"};